import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import 'dayjs/locale/en.js';
import 'dayjs/locale/pl.js';

import en from './locales/en.json';
import pl from './locales/pl.json';

const { VITE_LOCALE = 'en' } = import.meta.env;

await i18next.use(initReactI18next).init({
	defaultNS: 'translations',
	lng: VITE_LOCALE,
	resources: {
		en: { translations: en },
		pl: { translations: pl },
	},
});

export const t = (target: any, args?: any) => i18next.t(target, args) as string;

export default i18next;
